/* eslint-disable @typescript-eslint/naming-convention */
export interface EntraConfig {
  authority: string;
  client_id: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  post_logout_redirect_uri: string;
}

// Mirrors cognitoConfig.ts: values are injected by rspack DefinePlugin from
// process.env.XEC_ENTRA_* (.env). See doc/migration/azure.env for the dev1 values.
export const entraAuthConfig: EntraConfig = {
  // @ts-ignore
  authority: process.env.XEC_ENTRA_AUTHORITY || "",
  // @ts-ignore
  client_id: process.env.XEC_ENTRA_CLIENT_ID || "",
  // @ts-ignore
  redirect_uri: process.env.XEC_ENTRA_REDIRECT_URI || "",
  // @ts-ignore
  response_type: process.env.XEC_ENTRA_RESPONSE_TYPE || "code",
  // @ts-ignore
  scope: process.env.XEC_ENTRA_SCOPE || "openid profile",
  // @ts-ignore
  post_logout_redirect_uri: process.env.XEC_ENTRA_POST_LOGOUT_REDIRECT_URI || "",
};

// authority is the v2.0 issuer (…/<tenant>/v2.0); the logout endpoint lives at
// …/<tenant>/oauth2/v2.0/logout, so strip the trailing /v2.0 first.
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const entraSignOutRedirect = () => {
  const { authority, post_logout_redirect_uri } = entraAuthConfig;
  const base = authority.replace(/\/v2\.0\/?$/, "");
  const params = post_logout_redirect_uri
    ? `?post_logout_redirect_uri=${encodeURIComponent(post_logout_redirect_uri)}`
    : "";
  window.location.href = `${base}/oauth2/v2.0/logout${params}`;
};
